"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ComboboxOption_styled_exports = {};
__export(ComboboxOption_styled_exports, {
  StyledOption: () => StyledOption
});
module.exports = __toCommonJS(ComboboxOption_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_combobox_assets = require("../../../themes/combobox_assets");
var StyledOption = import_styled_components.default.li.withConfig({
  displayName: "ComboboxOptionstyled__StyledOption",
  componentId: "sc-1locrct-0"
})(function(_ref) {
  var theme = _ref.theme, separator = _ref.separator, optionsOverflow = _ref.optionsOverflow, selected = _ref.selected, disabled = _ref.disabled, current = _ref.current, multiSelect = _ref.multiSelect;
  var currentStyles = "\n      outline: 2px solid ".concat(theme.colors.beige[180], ";\n      outline-offset: -3px;\n    ");
  return (0, import_styled_components.css)(["display:flex;align-items:center;justify-content:space-between;color:", ";cursor:pointer;padding:20px 15px;white-space:", ";", ";font-weight:", ";&:hover{background-color:", ";}", " ", " ", " ", ";.select__option-content{", " ", " align-items:center;display:flex;overflow:hidden;width:90%;", " i{&:first-child{margin-right:5px;}&:last-child{margin-left:5px;}}}"], theme.colors.n[100], optionsOverflow === "ellipsis" ? "nowrap" : "normal", separator ? "border-top: 1px solid ".concat(theme.colors.beige[180], ";") : null, selected ? theme.typography.weights.bold : theme.typography.weights.regular, theme.colors.beige[100], selected && !multiSelect && (0, import_styled_components.css)(["&:after{content:'';display:inline-block;transform:rotate(45deg);width:6px;height:12px;border-bottom:2px solid ", ";border-right:2px solid ", ";}"], theme.colors.pr.base, theme.colors.pr.base), multiSelect && (0, import_styled_components.css)(["&:before{content:url(", ");display:inline-block;height:24px;margin-right:8px;}"], selected ? import_combobox_assets.checkBox : import_combobox_assets.box), current && "".concat(currentStyles), disabled && (0, import_mixins.disabledComboBoxOptionStyles)(theme), optionsOverflow === "ellipsis" && "text-overflow: ellipsis;", optionsOverflow === "word-wrap" && "word-wrap: break-word;", multiSelect && (0, import_styled_components.css)(["line-height:24px;"]));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledOption
});
//# sourceMappingURL=ComboboxOption.styled.js.map